import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import events from "./modules/events"

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    auth,
    events,
  },
  strict: debug,
});



// WEBPACK FOOTER //
// ./src/store/index.js